import { API } from '@/services/api/axios.js'
import { fetchPostmanMbp, useMock } from '../postman'
import type { Method } from 'axios'

export interface NoticeResponse {
	/** The notice message to display to users, or null if no notice exists */
	notice: null | string
	/** Array of validation error messages, if any */
	validationErrors: string[]
}

/**
 * Type guard to validate API response structure
 *
 * @param {any} res - The response object to validate
 * @returns {boolean} True if response matches INoticeResponse interface
 */
function isValidNoticeResponse(res: any): res is NoticeResponse {
	return res && (res.notice === null || typeof res.notice === 'string')
}

export async function fetchUserNotice(): Promise<NoticeResponse> {
	let response: Promise<NoticeResponse>
	const body = {
		url: 'public/user-notice',
		method: 'GET' as Method,
		eCode: 'BP-NFA-010'
	}

	if (useMock('NOTICE')) {
		response = (await fetchPostmanMbp(body)) as Promise<NoticeResponse>
	} else {
		response = (await API(body)) as Promise<NoticeResponse>
	}

	if (!isValidNoticeResponse(response)) {
		throw new Error('Invalid notice response format')
	}

	return response
}
